import React from "react";
import Routes from "./Routes";
// Add this to the top of src/App.jsx or src/main.jsx

function App() {
  return (
    <>
      <Routes />
      {/* Spacer for sticky action bar on mobile */}
      <div className="sticky-spacer" aria-hidden="true" />
    </>
  );
}

export default App;